import ApexChartContainer from "../../../Components/Charts/ApexChart/ApexChartContainer"

const ApexChart = () => {
  return (
    <ApexChartContainer/>
  )
}

export default ApexChart